// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCkC8jz_PrVWyf6YwjgQGqBPssBZGjGkXw",
    authDomain: "online-interactives.firebaseapp.com",
    projectId: "online-interactives",
    storageBucket: "online-interactives.firebasestorage.app",
    messagingSenderId: "432322874971",
    appId: "1:432322874971:web:c422f366624634c264b97e"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db };
